export const SX_THEME = {
    base: "vs-dark",
    inherit: true,
    rules: [
        { token: "op-num", foreground: "bb0000" },
        { token: "op-math", foreground: "ffb273" },
        { token: "op-bin", foreground: "00ddff" },
        { token: "op-pushdata", foreground: "666666" },
        { token: "op-control", foreground: "0077dd" },
        { token: "op-stack", foreground: "22dd44" },
        { token: "op-crypto", foreground: "fff700", fontStyle: "bold" },
        { token: "macros", foreground: "ae00ff", fontStyle: "bold" },
        { token: "funcs", foreground: "9966ff", fontStyle: "bold" },
        { token: "notes", foreground: "d1476f", fontStyle: "italic" },

        // Update token name for variables in the theme
        {
            "foreground": "#61afef",
            "fontStyle": "",
            "token": "variable"
        },

        // Update token name for functions in the theme
        {
            "foreground": "#00C0CB",
            "fontStyle": "bold",
            "token": "function.definition"
        },
        // {
        //     "foreground": "#61afef",
        //     "fontStyle": "",
        //     "token": "comment"
        // },
        // {
        //     "foreground": "#c678dd",
        //     "fontStyle": "italic",
        //     "token": "string"
        // },
        // {
        //     "foreground": "#e06c75",
        //     "fontStyle": "",
        //     "token": "constant.numeric"
        // },
        // {
        //     "foreground": "#61afef",
        //     "fontStyle": "bold",
        //     "token": "keyword"
        // },
        {
            "foreground": "#61afef",
            "fontStyle": "",
            "token": "support.function"
        },
        // {
        //     "foreground": "#be5046",
        //     "fontStyle": "bold",
        //     "token": "keyword.operator"
        // }
    ],
    colors: {
    },
}